import { gql, useSubscription } from '@apollo/client';
import { useContext, useEffect } from 'react';
import { CompanyContext } from '../../context/CompanyContext';
import React from 'react';
import { forNotification } from '../Common/forNotification';
import { LotFragments } from '../../graphql/lot.graphql';
import { Lot } from '../../types/lot/lot';
import { useAppDispatch } from '../../ui/pages/store';
import { lotSlice } from '../../providers/LotProvider';

const lotSubscription = gql`
  subscription lotNotification($companyId: String!) {
    lotNotification(companyId: $companyId) {
      companyId
      entities {
        ...Lot
      }
      topic
      date
    }
  }
  ${LotFragments.lot}
`;

export class LotNotificationResponse extends forNotification<Lot>('lotNotification') {}

export default function LotNotification({}) {
  const { currentCompany } = useContext(CompanyContext);
  const dispatch = useAppDispatch();

  if (!currentCompany) return null;

  const { data: lotNotification } = useSubscription<LotNotificationResponse>(lotSubscription, {
    variables: { companyId: currentCompany.id },
  });

  const handleLotNotification = (notification?: LotNotificationResponse) => {
    if (!notification?.lotNotification) return;
    const lotNotification = notification.lotNotification;

    switch (lotNotification.topic) {
      case 'CREATE':
      case 'UPDATE':
        dispatch(lotSlice.actions.add(lotNotification.entities));
        break;
      case 'DELETE':
        dispatch(lotSlice.actions.delete(lotNotification.entities));
        break;
    }
  };

  useEffect(() => {
    handleLotNotification(lotNotification);
  }, [lotNotification]);

  return <></>;
}
